module.exports = __webpack_public_path__ + "img/accessory_shirt_13.c6eb3262.svg";